export default {
    clean_phone(phone) {
        return phone.replaceAll(" ", "")
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "")
    },
}